

export function handleFilters() {

    let filters = document.querySelectorAll("[data-js-filter]");
    if (filters.length) {

        filters.forEach((filter) => {

            const buttons = filter.querySelectorAll('button[type=submit]');
            const groups = filter.querySelectorAll('[data-group]');

            buttons.forEach((btn) => {
                btn.addEventListener('click', (event) => {
                    event.preventDefault();
                    let url = buildUrl(groups);
                    window.location.href = url;
                });
            })

            groups.forEach((group) => {

                const options = group.querySelectorAll('input[type=radio]');
                let first = options[0]; // this should be "ALL";

                options.forEach((option) => {
                    option.addEventListener('click', function (evt) {

                        if (evt.target.value !== 'all') {
                            first.checked = false;
                        }

                        if (evt.target.value === 'all') {
                            options.forEach((option) => {
                                option.checked = false;
                            });
                            first.checked = true;
                        }

                    });
                });

            });

        });
    }

    function buildUrl(groups) {
        let url = '/knowledge-hub/';
        groups.forEach((group) => {
            const groupName = group.dataset.group;
            const options = group.querySelectorAll('input[type=radio]');
            let values = '';
            options.forEach((option) => {
                if (option.checked) {
                    let value = option.value;
                    if (value !== '') {
                        if (values !== '') {
                            values += ',';
                        }
                        values += value;
                    }
                }
            });
            if (values !== '') {
                url += groupName + '/' + values + '/';
            }
        });
        return url;

    }
}